import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ConfirmAlert } from 'modules/common/components/Alert';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import SubClassifications from '../components/sub-classification/container/LandSubClassContainer';
import * as actions from '../action';
import * as c from '../constant';
import LandSubItemContainer from '../components/sub-item/container/LandSubItemContainer';

function LandClassificationsContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  classificationId,
  getSingleLandClass,
  classificationInfo,
  removeLandSubClass,
  getLandClassificationsList,
  history,
  getSubClassificationsList,
  ordinanceRevisionId,
}) {
  const [activeTab, setActiveTab] = useState(1);
  const [formData, setFormData] = useState({
    scroll: 0,
  });
  const scrollref = React.createRef();

  const handleActivePage = (index) => () => {
    setActiveTab(index);
  };

  const scrollToLeft = (e) => {
    e.preventDefault();
    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const val = formData.scroll - slide < 0 ? 0 : formData.scroll - slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  const scrollToRight = (e) => {
    e.preventDefault();

    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const calculatedWidth = width - slide;
    const val =
      formData.scroll + slide > calculatedWidth
        ? calculatedWidth
        : formData.scroll + slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  useEffect(() => {
    if (_.isEmpty(classificationId)) return;
    getSingleLandClass(classificationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(classificationId)) return;
    getSingleLandClass(classificationId);
  }, [classificationId]);

  const removeSubClass = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to remove this Land Sub Classification?',
      () => {
        removeLandSubClass(classificationId, data.id, () => {
          getLandClassificationsList({ isPaginate: 1 });
          history.push(
            `/rpt/land/land-settings/land-classification/${classificationId}`
          );
          getSingleLandClass(classificationId);
          getSubClassificationsList(classificationId, { ordinance_revision_id: ordinanceRevisionId });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="container-fluid card-section-content">
      <div className="p-3">
        <div className="row bg-white pr-2 py-2 mb-2">
          <div className="col-12 d-flex ">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-add font-weight-bold my-2 px-4 ml-auto"
            >
              Add&nbsp;
              <i className="fas fa-plus" />
            </button>
          </div>
          <div className="col-12 d-flex">
            <div className="ml-auto">
              <button
                type="button"
                className="btn-blank"
                onClick={handleEdit(classificationInfo)}
              >
                <i className="far fa-edit icon-edit" />
              </button>
              <button
                type="button"
                className="btn-blank"
                onClick={handleRemove(classificationInfo)}
              >
                <i className="far fa-trash-alt icon-delete" />
              </button>
            </div>
          </div>
        </div>
        {!_.isEmpty(classificationInfo) ? (
          <React.Fragment>
            <div className="page-submenu d-flex justify-content-between align-content-center">
              <button
                type="button"
                className="tab-arrow left"
                onClick={scrollToLeft}
              >
                <div
                  style={{ cursor: 'pointer' }}
                  className={`fa fa-caret-left ${
                    +formData.scroll === 0 ? 'd-none' : ''
                  }`}
                />
              </button>
              <ul
                className="tab-list tab-scroll no-border scroll"
                ref={scrollref}
              >
                <li className="tab-item">
                  <button
                    type="button"
                    className={`btn-blank py-2 px-3 ${
                      activeTab === 1 ? 'active' : ''
                    }`}
                    onClick={handleActivePage(1)}
                  >
                    Sub Classification
                  </button>
                </li>
                <li className="tab-item">
                  <button
                    type="button"
                    className={`btn-blank py-2 px-3 ${
                      activeTab === 2 ? 'active' : ''
                    }`}
                    onClick={handleActivePage(2)}
                  >
                    Sub Classification Item
                  </button>
                </li>
              </ul>
              <button
                type="button"
                className="tab-arrow right"
                onClick={scrollToRight}
              >
                <div
                  style={{ cursor: 'pointer' }}
                  className={`fa fa-caret-right ${
                    +formData.totalwidth === +formData.rightdistance
                      ? 'd-none'
                      : ''
                  }`}
                />
              </button>
            </div>
            <div className="tabs-details">
              {activeTab === 1 && (
                <SubClassifications
                  classificationInfo={classificationInfo}
                  classificationId={classificationId}
                  removeSubClass={removeSubClass}
                  ordinanceRevisionId={ordinanceRevisionId}
                />
              )}
              {activeTab === 2 && (
                <LandSubItemContainer
                  classificationInfo={classificationInfo}
                  classificationId={classificationId}
                />
              )}
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

LandClassificationsContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  getSingleLandClass: PropTypes.instanceOf(Function).isRequired,
  classificationInfo: PropTypes.instanceOf(Object).isRequired,
  classificationId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  removeLandSubClass: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  getSubClassificationsList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  classificationInfo: _.get(api, `${c.GET_SINGLE_LAND_CLASS}.item`) || {},
  classificationId: _.get(match, 'params.classificationId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandClassificationsContent);
